import { Identity } from '@sohohouse/platform-client'

export default {
  state: () => ({
    fetching: false,
    failed: false
  }),
  actions: {
    async changePassword ({ commit, rootGetters },
      { oldPassword, newPassword, newPasswordConfirm }) {
      try {
        const token = rootGetters['user/accessToken']

        commit('fetching')

        const oAuthHost = this.$config.OAUTH_HOST
        const config = { oAuthHost }
        const identity = new Identity({ token, config: { identity: config } })
        await identity.changePassword(oldPassword, newPassword, newPasswordConfirm)
        commit('success')
        return {}
      } catch (e) {
        commit('failed')
        return {}
      }
    }
  },
  getters: {
    failed: s => s.failed,
    fetching: s => s.fetching
  },
  mutations: {
    fetching: s => { s.fetching = true },
    success: s => {
      s.fetching = false
      s.failed = false
    },
    failed: s => {
      s.fetching = false
      s.failed = true
    }
  }
}
